const MULTI_HYPHEN = /-+/g;
const NON_SLUG = /[^a-z0-9]+/g;
const VALID_SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function slugify(value: string): string {
  const normalized = value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(NON_SLUG, "-")
    .replace(MULTI_HYPHEN, "-")
    .replace(/^-+|-+$/g, "");

  return normalized || "article";
}

export function isValidSlug(value: string): boolean {
  return VALID_SLUG.test(value);
}

export function ensureUniqueSlug(baseSlug: string, existingSlugs: Iterable<string>): string {
  const used = new Set(existingSlugs);
  if (!used.has(baseSlug)) {
    return baseSlug;
  }

  let suffix = 2;
  while (used.has(`${baseSlug}-${suffix}`)) {
    suffix += 1;
  }

  return `${baseSlug}-${suffix}`;
}

export function generateArticleId(date: Date, existingIds: Iterable<string>): string {
  const day = date.toISOString().slice(0, 10).replaceAll("-", "");
  const prefix = `${day}-`;
  let maxIndex = 0;

  for (const id of existingIds) {
    if (!id.startsWith(prefix)) {
      continue;
    }
    const index = Number(id.slice(prefix.length));
    if (Number.isFinite(index)) {
      maxIndex = Math.max(maxIndex, index);
    }
  }

  return `${day}-${String(maxIndex + 1).padStart(3, "0")}`;
}
